import React from "react";
import { PopoverBody, UncontrolledPopover } from "reactstrap";

import style from "./Helper.module.scss";

const EarningsHelper = ({ children, quantities, earningCategoryName, earningTypeName }) => (
  <div id={`earnings-helper-${earningCategoryName}`} className={style.linkHelper}>
    {children}
    <UncontrolledPopover placement="right" target={`earnings-helper-${earningCategoryName}`} trigger="hover">
      <PopoverBody className={style.helper}>
        {quantities.map((item) => (
          <div key={`earning-${item.date}`}>
            {`${item.date}: ${item[earningCategoryName]} ${item[earningTypeName]} (status: ${item.status})`}
          </div>
        ))}
      </PopoverBody>
    </UncontrolledPopover>
  </div>
);

export default EarningsHelper;
